<template>
  <span>
    <v-container fluid class="pa-0 overflow-hidden" :style="{ height: getHeight + 'px' }"
      v-if="headerData && headerData.length > 0 && headerData[0].HeaderImage !== ''">

      <v-carousel v-if="headerData.length > 1" cycle :height="getHeight" show-arrows="hover" hide-delimiters>
        <span v-for="(wwe, index) in headerData" :key="index">
          <v-carousel-item v-if="wwe.HeaderImage" :height="getHeight" :src="wwe.HeaderImage"
            :alt="wwe.AltText" cover>

            <v-container :style="{ height: getHeight + 'px' }" class="fill-height d-flex align-center">

                      <v-card :style="{ width: cardwidth + '%' }" class="headercard">
                        <v-container>
                        <span class="font-weight-bold h" style="font-size: 1.5rem"> {{ wwe.HeaderImageTitle }} </span>

                          <p class="pb-0 pt-1 t">{{ wwe.HeaderImageDescription }}</p>
                        </v-container>
                        <v-container class="b pt-1" v-if="wwe.HeaderButton">
                          <span v-for="(btnHeader, i) in wwe.HeaderButton" :key="i">
                            <NuxtLink v-if="btnHeader.ButtonName && btnHeader.LinkCode" :to="$methods.pageLinkByCode(btnHeader.LinkCode)">
                              <v-btn  :class="'btn' + [i]" class="ma-1 text-decoration-none text-none">{{
                                btnHeader.ButtonName
                              }}</v-btn>
                            </NuxtLink>
                          </span>

                        </v-container>
                      </v-card>
            </v-container>

        </v-carousel-item>
      </span>
      </v-carousel>

      <v-img v-if="headerData.length == 1" cycle :height="getHeight" show-arrows="hover" hide-delimiters>
        <span v-for="(wwe, index) in headerData" :key="index">
        <v-img v-if="wwe.HeaderImage" :height="getHeight" :src="wwe.HeaderImage" :alt="wwe.AltText"
          cover>
          <v-container :style="{ height: getHeight + 'px' }" class="fill-height d-flex align-center">
                    <v-card :style="{ width: cardwidth + '%' }" class="headercard">
                      <v-container>
                        <span class="font-weight-bold h" style="font-size: 1.5rem"> {{ wwe.HeaderImageTitle }} </span>

                        <p class="pb-0 pt-2 t">{{ wwe.HeaderImageDescription }}</p>
                      </v-container>
                      <v-container class="b pt-1" v-if="wwe.HeaderButton">
                        <span v-for="(btnHeader, i) in wwe.HeaderButton" :key="i">
                          <NuxtLink v-if="btnHeader.ButtonName && btnHeader.LinkCode" :to="$methods.pageLinkByCode(btnHeader.LinkCode)">
                            <v-btn :class="'btn' + [i]" class="ma-1 text-decoration-none text-none">{{
                              btnHeader.ButtonName
                            }}</v-btn>
                          </NuxtLink>
                        </span>

                      </v-container>
                    </v-card>
          </v-container>
        </v-img>
      </span>
      </v-img>
    </v-container>
  </span>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from "vue";
const { SECONDS_BANNER_SLIDE } = useRuntimeConfig().public;
const { $methods } = useNuxtApp()
const props = defineProps({
  header: {
    type: Object,
    default: () => []
  },
});

let headerData = props.header;

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

// Replace /PUBLIC with PUBLIC_DATA_URL in development environment to load icons correctly from bucket
if (isDev){
  headerData = headerData.map(item => ({ ...item, HeaderImage: isDev && item.HeaderImage ? item.HeaderImage.replaceAll("/PUBLIC", PUBLIC_DATA_URL) : item.HeaderImage }))
}

let headerCounter = ref(0);
let timeoutHeader = ref(null)
const getHeight = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 300;
    case "sm":
      return 325;
    case "md":
      return 350;
    case "lg":
      return 360;
    case "xl":
      return 390;
    case "xxl":
      return 440;
    default:
      return 300;
  }
});

const cardwidth = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 100;
    case "sm":
      return 75;
    case "md":
      return 60;
    case "lg":
      return 50;
    case "xl":
      return 45;
    case "xxl":
      return 40;
    default:
      return 50;
  }
});

onMounted(() => {
  clearInterval(timeoutHeader.value)
  if (props.header && props.header.length > 1) {
    timeoutHeader.value = setInterval(function () {
      headerCounter.value = (headerCounter.value < props.header.length - 1) ? headerCounter.value + 1 : 0;
    }, (SECONDS_BANNER_SLIDE > 0 ? SECONDS_BANNER_SLIDE : 5) * 1000)
    // prevent SECONDS_BANNER_SLIDE 0
  }
});
onBeforeUnmount(() => {
  clearInterval(timeoutHeader.value)

})
</script>